// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

class Project extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: props.activeMenu,//liuxue,uk,usa,au,language,culture
        };


    }

    componentDidMount() {
        const { match } = this.props;
        const { id } = match.params;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

    }


    render() {
        let { universitiyInfo } = this.state;
        return (
            <div className='dv_project_body_left'>
                <div className='dv_project_fixed_left alignleft'>
                    <Link to={`/convoy/1`} className={this.state.activeMenu == '1' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>护航计划项目方案</Link>
                    <Link to={`/convoy/2`} className={this.state.activeMenu == '2' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>护航计划</Link>
                    <Link to={`/convoy/3`} className={this.state.activeMenu == '3' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>定位</Link>
                    <Link to={`/convoy/4`} className={this.state.activeMenu == '4' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>产品体系详解</Link>
                    <Link to={`/convoy/5`} className={this.state.activeMenu == '5' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>国际语言课程类</Link>
                    <Link to={`/convoy/6`} className={this.state.activeMenu == '6' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>涉外合作办学学历贯通</Link>
                    <Link to={`/convoy/7`} className={this.state.activeMenu == '7' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>技术支持与服务</Link>
                    <Link to={`/convoy/8`} className={this.state.activeMenu == '8' ? 'dv_porject_menu_normal dv_porject_menu_selected clickable' : 'dv_porject_menu_normal clickable'}>职教出海服务</Link>
                </div>
            </div>
        );
    }
}

export default withRouter(Project);